/* ALBEUX SLIDE FOR "YOU MAY ALSO LIKE" (2 Nov 2026). Separate from albeux-slide.js, which is NOT touched. Loaded from snippets/view-transition-opt-in.liquid.
   What it does: on a product page, tapping a bag in "You may also like" opens that product with the very same slide as collection -> product (same length 1.4s, same curve, same dim,
   the photograph glides a little slower than the page, the details open left to right once it has landed). Going back slides the page out to the left and the product page you came from is underneath, in the same scroll position.
   Pages can be stacked (bag after bag); each Back closes one. If anything goes wrong the product simply opens the normal way. Reduced-motion visitors, the theme editor and frames get the normal way too.
   It only ever acts on links inside "You may also like" on a product page. Collection pages, every other link and every other effect are left to albeux-slide.js and the theme exactly as before.
   To switch it off, delete the albeux-slide-recs line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albSlideRecs) return;
  window.__albSlideRecs = true;
  var d = document.documentElement;
  try {
    if (window.top !== window || d.classList.contains('shopify-design-mode')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!Element.prototype.animate || !window.fetch || !window.DOMParser) return;
  } catch (e) { return; }

  var DUR = 1400;
  var EASE = 'cubic-bezier(0.6, 0, 0.15, 1)';
  var DIM = 0.26;
  var stack = [];
  var busy = false;
  var opening = null;
  var pre = {};
  var seq = 0;

  /* the page underneath keeps its details while the new page arrives (the details of the arriving page wait unseen, the one underneath must not) */
  try {
    var st = document.createElement('style');
    st.setAttribute('data-alb-slide-recs', '1');
    st.textContent = 'html:not(#q1):not(#q2):not(#q3):not(#q4):not(#q5):not(#q6):not(#q7):not(#q8):not(#q9) body main[data-alb-base] .product-details{opacity:1!important}';
    document.head.appendChild(st);
  } catch (e) {}

  function isProd(p) { return String(p || '').indexOf('/products/') > -1; }
  function mk(css) { var e = document.createElement('div'); e.style.cssText = css; return e; }
  function hb() {
    var b = 0;
    ['header-group', 'header-component'].forEach(function (id) {
      var h = document.getElementById(id);
      if (h) b = Math.max(b, h.getBoundingClientRect().bottom);
    });
    return Math.max(0, Math.min(b, (window.innerHeight || 800) * 0.5));
  }
  function jump(y) {
    d.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
  }
  function cur() { return document.getElementById('MainContent'); }
  function isProductPage() {
    var m = cur();
    return !!m && String(m.getAttribute('data-template') || '').indexOf('product') === 0;
  }
  function fetchPage(url) {
    if (!pre[url]) {
      pre[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (r) {
        if (!r.ok) throw new Error('x');
        return r.text();
      });
      pre[url].catch(function () { delete pre[url]; });
    }
    return pre[url];
  }
  function photoReady(node) {
    return new Promise(function (res) {
      var img = node.querySelector('media-gallery img');
      var t = setTimeout(res, 1800);
      var done = function () {
        clearTimeout(t);
        var t2 = setTimeout(res, 1200);
        var fin = function () { clearTimeout(t2); res(); };
        try { if (img && img.decode) { img.decode().then(fin, fin); return; } } catch (e) {}
        fin();
      };
      if (!img || (img.complete && img.naturalWidth)) { done(); return; }
      try { img.loading = 'eager'; } catch (e) {}
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }
  /* the page underneath is taken out of the flow without being hidden by display (so none of its animations start again when it comes back) */
  var AWAY = 'position:absolute;left:0;top:0;width:100%;height:0;min-height:0;max-height:0;overflow:hidden;visibility:hidden;pointer-events:none;transform:translate3d(-300vw,0,0);';
  function putAway(m) {
    m.setAttribute('data-alb-prev-style', m.getAttribute('style') || '');
    m.setAttribute('style', (m.getAttribute('style') || '') + ';' + AWAY);
  }
  function bringBack(m) {
    var s = m.getAttribute('data-alb-prev-style');
    m.removeAttribute('data-alb-prev-style');
    if (s) m.setAttribute('style', s); else m.removeAttribute('style');
  }

  /* which links start the slide: only the bags of "You may also like" on a product page */
  function allowed(a, u) {
    var m = cur();
    if (!m || !isProductPage() || !m.contains(a)) return false;
    if (!a.closest('product-recommendations')) return false;
    if (!isProd(u.pathname) || u.pathname === location.pathname) return false;
    return true;
  }

  /* ---------- OPEN ---------- */
  function open(url) {
    var base = cur();
    if (!base || busy) return false;
    busy = true;
    var n = ++seq;
    var h = hb();
    var oldTitle = document.title;
    var oldPath = location.pathname;
    var dim = null, wrap = null;
    var tok = { dead: false, anims: [], pushed: false, fromPath: oldPath, real: null };
    opening = tok;
    /* the history entry of the new page is made now, inside the tap, so Back lands on the page you came from */
    try { history.pushState({ alb: 2, d: stack.length + 1 }, '', url); tok.pushed = true; } catch (e) {}
    base.setAttribute('data-alb-base', '1');
    function undoReal() {
      if (tok.real) {
        try { tok.real.remove(); } catch (e) {}
        bringBack(base);
        base.id = 'MainContent';
        document.title = oldTitle;
        tok.real = null;
      }
    }
    tok.abort = function () {
      tok.dead = true;
      undoReal();
      for (var i = 0; i < tok.anims.length; i++) { try { tok.anims[i].cancel(); } catch (e) {} }
      try { if (wrap) wrap.remove(); if (dim) dim.remove(); } catch (e) {}
      base.removeAttribute('data-alb-base');
      d.classList.remove('alb-zooming', 'alb-hold');
      d.style.scrollBehavior = '';
      if (opening === tok) opening = null;
      busy = false;
    };
    function bail() {
      if (tok.dead) return;
      tok.dead = true;
      undoReal();
      try { if (wrap) wrap.remove(); if (dim) dim.remove(); } catch (e) {}
      base.removeAttribute('data-alb-base');
      d.classList.remove('alb-zooming', 'alb-hold');
      if (opening === tok) opening = null;
      busy = false;
      if (tok.pushed) location.replace(url); else location.href = url;
    }
    fetchPage(url).then(function (html) {
      if (tok.dead) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var pm = doc.getElementById('MainContent');
      if (!pm || String(pm.getAttribute('data-template') || '').indexOf('product') !== 0) throw new Error('x');
      var node = document.importNode(pm, true);
      node.id = 'MainContent-alb2';
      var title = doc.title || oldTitle;
      d.classList.remove('alb-landed');
      d.classList.add('alb-zooming', 'alb-zoomed');
      dim = mk('position:fixed;left:0;right:0;bottom:0;top:' + h + 'px;background:#000;opacity:0;pointer-events:none;z-index:40;');
      wrap = mk('position:fixed;left:0;right:0;bottom:0;top:' + h + 'px;overflow:clip;background:#000;z-index:41;transform:translate3d(-100%,0,0);will-change:transform;');
      wrap.appendChild(node);
      document.body.appendChild(dim);
      document.body.appendChild(wrap);
      return photoReady(node).then(function () {
        return new Promise(function (r) { requestAnimationFrame(function () { requestAnimationFrame(r); }); });
      }).then(function () {
        if (tok.dead) return;
        var slide = wrap.animate([{ transform: 'translate3d(-100%,0,0)' }, { transform: 'translate3d(0,0,0)' }], { duration: DUR, easing: EASE, fill: 'forwards' });
        var dimAnim = dim.animate([{ opacity: 0 }, { opacity: DIM }], { duration: DUR, easing: EASE, fill: 'forwards' });
        tok.anims.push(slide, dimAnim);
        var first = node.querySelector('media-gallery .media-gallery__grid > *:first-child, media-gallery slideshow-slide:first-child');
        var im = first && first.querySelector('img, video');
        if (first && im) {
          first.style.overflow = 'hidden';
          tok.anims.push(im.animate([
            { transform: 'translate3d(-7%,0,0) scale(1.12)', transformOrigin: '0 50%' },
            { transform: 'translate3d(0,0,0) scale(1)', transformOrigin: '0 50%' }
          ], { duration: DUR, easing: EASE }));
        }
        return slide.finished.then(function () {
          if (tok.dead) return;
          /* Landed: a second copy of the page is built in the page under the sliding frame (which looks identical); the frame goes once the copy has its photograph drawn */
          var y = window.scrollY || 0;
          var real = document.importNode(pm, true);
          real.id = 'MainContent';
          base.id = 'MainContent-prev' + n;
          putAway(base);
          /* the new page goes BEFORE the one underneath, so its own ids (its "You may also like") are found first */
          base.parentNode.insertBefore(real, base);
          tok.real = real;
          d.classList.add('alb-hold');
          document.title = title;
          jump(0);
          return photoReady(real).then(function () {
            return new Promise(function (r) { requestAnimationFrame(function () { requestAnimationFrame(function () { setTimeout(r, 140); }); }); });
          }).then(function () {
            if (tok.dead) return;
            if (first) first.style.overflow = '';
            try { wrap.remove(); dim.remove(); } catch (e5) {}
            stack.push({ base: base, baseY: y, baseTitle: oldTitle, basePath: oldPath, path: new URL(url, location.href).pathname, node: real });
            opening = null;
            busy = false;
            /* the details open from left to right, as the collection title does */
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                d.classList.remove('alb-zooming');
                d.classList.add('alb-landed');
                d.style.scrollBehavior = '';
                setTimeout(function () { d.classList.remove('alb-hold'); }, 900);
              });
            });
          });
        });
      });
    }).catch(bail);
    return true;
  }

  /* ---------- CLOSE ---------- */
  function close() {
    var s = stack.pop();
    if (!s) return;
    busy = true;
    d.classList.add('alb-hold');
    setTimeout(function () { d.classList.remove('alb-hold'); }, DUR + 1500);
    var h = hb();
    var sy = window.scrollY || 0;
    var dim = mk('position:fixed;left:0;right:0;bottom:0;top:' + h + 'px;background:#000;opacity:' + DIM + ';pointer-events:none;z-index:40;');
    var wrap = mk('position:fixed;left:0;right:0;bottom:0;top:' + h + 'px;overflow:clip;background:#000;z-index:41;');
    var inner = mk('transform:translate3d(0,' + (-sy) + 'px,0);');
    inner.appendChild(s.node);
    wrap.appendChild(inner);
    document.body.appendChild(dim);
    document.body.appendChild(wrap);
    /* the page underneath is put back exactly as it was, in the same scroll position */
    bringBack(s.base);
    s.base.removeAttribute('data-alb-base');
    s.base.id = 'MainContent';
    document.title = s.baseTitle;
    jump(s.baseY);
    d.classList.remove('alb-zooming');
    var slide = wrap.animate([{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(-100%,0,0)' }], { duration: DUR, easing: EASE, fill: 'forwards' });
    dim.animate([{ opacity: DIM }, { opacity: 0 }], { duration: DUR, easing: EASE, fill: 'forwards' });
    try {
      var first = s.node.querySelector('media-gallery .media-gallery__grid > *:first-child, media-gallery slideshow-slide:first-child');
      var im = first && first.querySelector('img, video');
      if (first && im) {
        first.style.overflow = 'hidden';
        im.animate([
          { transform: 'translate3d(0,0,0) scale(1)', transformOrigin: '0 50%' },
          { transform: 'translate3d(-7%,0,0) scale(1.12)', transformOrigin: '0 50%' }
        ], { duration: DUR, easing: EASE, fill: 'forwards' });
      }
    } catch (e) {}
    slide.finished.then(function () {
      try { wrap.remove(); dim.remove(); } catch (e) {}
      d.style.scrollBehavior = '';
      busy = false;
    }, function () { try { wrap.remove(); dim.remove(); } catch (e) {} busy = false; });
  }

  /* the pages built here are taken away at once (no slide) and the page underneath is put back as it was */
  function unwind() {
    while (stack.length) {
      var s = stack.pop();
      try { s.node.remove(); } catch (e) {}
      bringBack(s.base);
      s.base.removeAttribute('data-alb-base');
      s.base.id = 'MainContent';
      document.title = s.baseTitle;
    }
    d.classList.remove('alb-zooming', 'alb-hold');
    d.style.scrollBehavior = '';
  }

  /* which step of the chain a history entry is (0 = not one of ours) */
  function depthOf() {
    var s = history.state;
    return (s && s.alb === 2 && typeof s.d === 'number') ? s.d : 0;
  }
  /* registered in the capture phase so it runs BEFORE the collection slide's own back handling */
  window.addEventListener('popstate', function () {
    var dep = depthOf();
    var L = stack.length;
    /* back while the new page is still sliding in: the slide is dropped, the page underneath is already there */
    if (opening) { if (dep === L) opening.abort(); return; }
    /* forward onto a page that is no longer built: just load it */
    if (dep > L) { location.reload(); return; }
    if (dep === L) return;
    /* one step back: the page slides out */
    if (dep === L - 1) { close(); return; }
    /* further back than one step: the pages built here go at once and the page underneath is put back as it was; the other script (or the browser) does the rest */
    var firstPath = stack[0].basePath;
    unwind();
    if (isProd(location.pathname) && location.pathname !== firstPath) location.reload();
  }, true);

  /* ---------- the taps ---------- */
  function linkOf(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    if (t.closest('.albeux-swatch, button, input, select, textarea')) return null;
    var a = t.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return null;
    return a;
  }
  function urlOf(a) {
    try { var u = new URL(a.getAttribute('href'), location.href); return u.origin === location.origin ? u : null; } catch (e) { return null; }
  }
  document.addEventListener('pointerdown', function (e) {
    try {
      if (busy) return;
      var a = linkOf(e);
      var u = a && urlOf(a);
      if (u && allowed(a, u)) fetchPage(u.href);
    } catch (err) {}
  }, true);
  document.addEventListener('click', function (e) {
    try {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = linkOf(e);
      var u = a && urlOf(a);
      if (!u || !allowed(a, u)) return;
      if (busy) { e.preventDefault(); return; }
      if (open(u.href)) { e.preventDefault(); e.stopPropagation(); }
    } catch (err) {}
  }, true);
})();
